var map = {
	"./pc-module-trend-1.vue": 97936,
	"./pc-module-trend-2.vue": 69214,
	"./pc-module-trend-3.vue": 85869,
	"./pc-module-trend-4.vue": 56008,
	"./pc-module-trend-5.vue": 79214,
	"./pc-module-trend-6.vue": 2840,
	"./pc-module-trend-7.vue": 10743,
	"./pc-module-trend-8.vue": 78925,
	"./pc-module-trend-9.vue": 40805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81672;